import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import Modal from 'react-modal';

import {
  fetchProject,
  fetchNotifications} from '../../actions/project_actions';
import { modalStyle } from '../../constants';

import UserProfile from '../global/UserProfile';

class ProjectHeader extends Component {
  // static PropTypes = {
  //   projectId: PropTypes.string.isRequired,
  //   notifications: PropTypes.array.isRequired,
  //   info: PropTypes.object.isRequired,
  //   fetchProject: PropTypes.func.isRequired,
  //   fetchNotifications: PropTypes.func.isRequired,
  // }

  constructor (props) {
    super(props);
    this.state = {
      showNotifications: false,
    }
    this.toggleNotifications = this.toggleNotifications.bind(this);
  }

  UNSAFE_componentWillMount () {
    this.props.fetchProject(this.props.projectId);
    this.props.fetchNotifications(this.props.projectId);
  }

  toggleNotifications () {
    this.setState({ showNotifications: !this.state.showNotifications });
  }

  renderNotificationCounter () {
    const { notifications } = this.props;
    if (notifications.length === 0) return null;

    return (
      <div
        className="notifications"
        onClick={this.toggleNotifications}
      >
        <div className="counter">
          {notifications.length}
        </div>
      </div>
    )
  }

  renderNotifications () {
    const { notifications } = this.props;
    return (
      <Modal
        isOpen={this.state.showNotifications}
        style={modalStyle}
        contentLabel="Notification modal"
      >
        <div className="notification-modal">
          <h1>Notifications</h1>
          <ul className="notification-list">
            { notifications.map(notification =>
              <li key={notification.id}>
                <h4>{notification.subject}</h4>
                <p>{notification.message}</p>
              </li>
            )}
          </ul>
        </div>
        <div className="modal-close" onClick={this.toggleNotifications}>
          <span className="close"></span>
        </div>
      </Modal>
    );
  }

  render () {
    const { info } = this.props;

    return (
      <div>
        <div className="row-wide fixed-header no-print">
          <div className="col s12">
            <h2>
              {info.projectId}
              <span className="separator"/>
              {info.projectDescription}
            </h2>
            {this.renderNotificationCounter()}
            <UserProfile />
          </div>
        </div>
        {this.renderNotifications()}
      </div>
    );
  }

}

ProjectHeader.propTypes = {
  projectId: PropTypes.string.isRequired,
  notifications: PropTypes.array.isRequired,
  info: PropTypes.object.isRequired,
  fetchProject: PropTypes.func.isRequired,
  fetchNotifications: PropTypes.func.isRequired
};

function mapStateToProps (state, ownProps) {
  return {
    projectId: ownProps.projectId,
    info: state.projectsStore.info,
    notifications: state.projectsStore.notifications,
  };
}

export default connect(mapStateToProps, {
  fetchProject,
  fetchNotifications,
})(ProjectHeader);